import { produce } from 'immer';
import {
  SET_DELIVERED_ORDERS,
  SET_CURRENT_COMPLETED_TAB,
  SET_RETURNED_ORDERS,
  SET_COMPLETED_ORDERS,
  SET_CANCELED_ORDERS,
} from 'store/constants/action-types';

const initialState = {
  delivered: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  returned: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  canceled: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  all: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  currentTab: 'delivered',
};

export const completedOrdersReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_DELIVERED_ORDERS:
        draft.delivered = action.payload;
        break;
      case SET_RETURNED_ORDERS:
        draft.returned = action.payload;
        break;
      case SET_COMPLETED_ORDERS:
        draft.all = action.payload;
        break;
      case SET_CANCELED_ORDERS:
        draft.canceled = action.payload;
        break;
      case SET_CURRENT_COMPLETED_TAB:
        draft.currentTab = action.payload;
        break;
      default:
    }
  });

export default completedOrdersReducer;
